module.exports = __webpack_public_path__ + "img/hero.efeeb0d6.gif";